module.exports = __webpack_public_path__ + "img/carpenter-pool.2ff4693e.webp";